import { useState } from "react";
import { Sparkles, FileSearch } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage, isPaywallError } from "@/lib/api";

const DOC_TYPES = ["application/pdf", "text/plain", "text/csv", "text/markdown", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/msword"];
const SUGGESTIONS = ["Resuma este documento.", "Qual a data de vencimento?", "Existe algum valor mencionado?", "Quais são os pontos mais importantes?"];

export function DocumentAsk({ attachments, isPremium, onPaywall }) {
  const docs = (attachments || []).filter((a) => DOC_TYPES.includes(a.content_type));
  const [fileId, setFileId] = useState(docs[0]?.id);
  const [q, setQ] = useState("");
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  if (!docs.length) return null;

  const ask = async (question) => {
    if (!isPremium) return onPaywall("Resumo e perguntas sobre documentos estão disponíveis no Clicou, Guardou!+.");
    setBusy(true); setResult(null);
    try { const { data } = await api.post("/ai/document/ask", { file_id: fileId, question }); setResult(data); }
    catch (e) { if (isPaywallError(e)) onPaywall(errorMessage(e)); else toast.error(errorMessage(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="ga-card mt-4 p-4" data-testid="document-ask">
      <div className="flex items-center gap-2 text-sm font-semibold"><FileSearch size={18} /> Resumo inteligente do documento {!isPremium && <span className="rounded-full px-2 py-0.5 text-[10px] font-bold text-white" style={{ background: "#7657E8" }}>Premium</span>}</div>
      {docs.length > 1 && <select value={fileId} onChange={(e) => setFileId(e.target.value)} className="ga-input mt-2 py-2 text-sm" data-testid="document-ask-select">{docs.map((d) => <option key={d.id} value={d.id}>{d.filename}</option>)}</select>}
      <div className="mt-3 flex flex-wrap gap-2">{SUGGESTIONS.map((s) => <button key={s} onClick={() => ask(s)} disabled={busy} className="ga-surface rounded-full px-3 py-1.5 text-xs" data-testid="document-ask-suggestion">{s}</button>)}</div>
      <form onSubmit={(e) => { e.preventDefault(); if (q.trim().length >= 2) ask(q); }} className="mt-3 flex gap-2">
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Pergunte algo sobre o documento…" className="ga-input flex-1 py-2 text-sm" data-testid="document-ask-input" />
        <button type="submit" disabled={busy || q.trim().length < 2} className="ga-btn-primary px-4 py-2" data-testid="document-ask-submit"><Sparkles size={16} /></button>
      </form>
      {busy && <p className="ga-muted mt-3 text-xs" data-testid="document-ask-loading">Lendo o documento…</p>}
      {result && (
        <div className="mt-3 rounded-2xl p-3 text-sm leading-relaxed" style={{ background: "var(--ga-bg)" }} data-testid="document-ask-answer">
          <p className="whitespace-pre-wrap">{result.answer}</p>
          {result.highlights?.length > 0 && <ul className="ga-muted mt-2 space-y-1 text-xs">{result.highlights.map((h, i) => <li key={i}>“{h}”</li>)}</ul>}
        </div>
      )}
    </div>
  );
}
